
import { mapActions, mapGetters, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import ClienteData, { ClienteDataRequired } from "./ClienteData";
import { mask } from "vue-the-mask";
import SistemaMixin from "../../Application/mixins/SistemaMixin";

export default {
  name: "app-cliente-form",
  mixins: [validationMixin, SistemaMixin],
  directives: {
    mask,
  },
  watch: {
    cliente(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
      }
    },
  },
  data() {
    return {
      tabIndex: 0,
      form: {},
      cliente: new ClienteData({}),
      plans: [],
      nivelPartner: {
        nivel: 1,
        selo: null,
      },
      licencas: null,
    };
  },
  validations: {
    form: ClienteDataRequired,
  },
  async mounted() {
    await this.getDataInit();

    if (!this.isRevenda) {
      this.$router.push({ name: "dashboard" });
    }
    this.nivelPartner = this.nivelPartnerUsuario;
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      await this.getLicencas();
      this.cliente = new ClienteData({});
      this.plans = await this.getPlans();
    },
    async getLicencas() {
      const { data } = await this.$http.post("/empresa/total-licencas", {
        id_empresa: this.currentUser.usuario_empresa.id_empresa,
      });

      this.licencas = data.total;
    },
    setParceriroRevenda() {
      this.form.parceiro_revenda =
        this.form.parceiro_revenda == true ? false : true;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setActivePreviousTab() {
      this.tabIndex = parseInt(localStorage.getItem("builderTab")) || 0;
      const links = this.$refs["builder-tab"].querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.$refs["builder-tab"]
        .querySelector(`[data-tab="${this.tabIndex}"]`)
        .classList.add("active");
    },
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      event.target.classList.add("active");
    },

    async onSubmit() {
      const submitButton = this.$refs["submit_emitente"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        if (!this.cliente.id_plan) {
          this.$toast.warning("Selecione um plano para o cliente!");
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        this.cliente.id_revenda = this.currentUser.usuario_empresa.id_empresa;

        if (this.cliente.parceiro_revenda) {
          if (this.cliente.licenca_parceiro > this.licencas) {
            this.$toast.warning(
              "As licenças atribuídas são maiores do que a quantidade disponível em estoque."
            );
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
            submitButton.removeAttribute("disabled", "");

            return;
          }
          this.cliente.revenda = true;
        }

        await this.$http.post("empresa/create", this.cliente);

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );

        this.$toast.success("Cliente cadastrado com sucesso!");

        submitButton.removeAttribute("disabled", "");
        this.$router.push({ name: "clientesLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
  computed: {
    ...mapGetters(["isRevenda"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    nivelPartnerUsuario() {
      return (
        this.currentUser?.usuario_empresa?.empresa?.nivel_revenda ||
        this.currentUser?.empresa?.nivel_revenda ||
        this.currentUser?.empresa?.dados_revenda?.nivel_revenda ||
        this.currentUser?.nivel_revenda || {
          nivel: 1,
          selo: null,
        }
      );
    },
    bloqueiaCadastro() {
      if (this.licencas === null) return true; // enquanto carrega
      return this.licencas === 0;
    },
  },
};
